import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import router from './routes/index';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { AuthProvider } from './helpers/AuthContext'; // ✅ import AuthProvider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AuthProvider> {/* ✅ Wrap app here */}
      <RouterProvider router={router} />
    </AuthProvider>
  </Provider>
);

reportWebVitals();
